(function () {
  'use strict';

  function initSection(sectionId) {
    const section = document.querySelector('.ugc-videos-' + sectionId);
    const viewport = document.getElementById('ugcCarouselViewport-' + sectionId);
    const track = document.getElementById('ugcCarouselTrack-' + sectionId);
    const prevBtn = document.getElementById('ugcPrevBtn-' + sectionId);
    const nextBtn = document.getElementById('ugcNextBtn-' + sectionId);

    if (!track || !viewport || !section) return;
    const isGridLayout = section.dataset.ugcLayout === 'grid';

    const items = track.querySelectorAll('.ugc-videos__item');
    if (items.length === 0) return;

    let currentIndex = 0;

    const isMobile = () => window.innerWidth < 1024;

    const getItemsPerPage = () => {
      if (window.innerWidth >= 1024) return 4;
      if (window.innerWidth >= 640) return 2;
      return 1.4;
    };

    const getGap = () => (window.innerWidth < 640 ? 16 : 24);

    const updateCarousel = () => {
      if (isGridLayout) return;
      const item = items[0];
      if (!item) return;

      const itemWidth = item.offsetWidth;
      const gap = getGap();

      if (isMobile()) {
        viewport.scrollTo({
          left: (itemWidth + gap) * currentIndex,
          behavior: 'smooth',
        });
      } else {
        track.style.transform = `translateX(-${(itemWidth + gap) * currentIndex}px)`;
      }

      const maxIndex = Math.max(0, items.length - Math.floor(getItemsPerPage()));

      if (prevBtn) {
        prevBtn.style.opacity = currentIndex <= 0 ? '0.5' : '1';
        prevBtn.style.pointerEvents = currentIndex <= 0 ? 'none' : 'auto';
      }

      if (nextBtn) {
        nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
        nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto';
      }
    };

    nextBtn?.addEventListener('click', () => {
      const maxIndex = Math.max(0, items.length - Math.floor(getItemsPerPage()));
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });

    prevBtn?.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    if (viewport) {
      let scrollTimer;
      viewport.addEventListener(
        'scroll',
        () => {
          if (!isMobile()) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            const item = items[0];
            if (!item) return;
            const newIndex = Math.round(viewport.scrollLeft / (item.offsetWidth + getGap()));
            if (newIndex !== currentIndex && newIndex >= 0 && newIndex < items.length) {
              currentIndex = newIndex;
            }
          }, 50);
        },
        { passive: true }
      );
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCarousel, 100);
    });

    const initVideoControls = () => {
      const pauseTimestamps = new Map();

      section.addEventListener('click', (e) => {
        const playBtn = e.target.closest('.ugc-videos__play-overlay');
        if (!playBtn) return;

        const container = playBtn.closest('.ugc-videos__video');
        const video = container?.querySelector('video');
        if (!video) return;

        const videoId = video.src || video.querySelector('source')?.src;
        if (videoId) {
          const justPaused = pauseTimestamps.get(videoId);
          if (justPaused && Date.now() - justPaused < 250) {
            return;
          }
        }

        if (video.paused) {
          container.classList.add('is-playing');
          video.muted = false;
          video.play();
        }
      });

      section.querySelectorAll('video').forEach((video) => {
        const container = video.closest('.ugc-videos__video');
        if (!container) return;

        const videoId = video.src || video.querySelector('source')?.src;

        video.addEventListener('play', () => {
          if (!container.classList.contains('is-playing')) {
            container.classList.add('is-playing');
          }
        });

        video.addEventListener('pause', () => {
          if (videoId) {
            pauseTimestamps.set(videoId, Date.now());
          }
        });

        video.addEventListener('ended', () => {
          container.classList.remove('is-playing');
        });

        // Click anywhere on the video body to toggle pause when playing.
        // Browsers route control-bar clicks to the shadow DOM, so they
        // don't reach this handler.
        video.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        });
      });
    };

    updateCarousel();
    initVideoControls();
  }

  function init() {
    document.querySelectorAll('[data-ugc-videos-section]').forEach((el) => {
      const id = el.getAttribute('data-ugc-videos-section');
      if (id) initSection(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
